import { Colors } from '~/themes/colors';

export const DocumentSolidIcon = ({ color = Colors.secondary_500 }) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.80005 4.69324C4.80005 3.39727 5.87457 2.34668 7.20005 2.34668H12.703C13.3395 2.34668 13.95 2.59391 14.4 3.03397L18.4971 7.0398C18.9472 7.47986 19.2 8.07672 19.2 8.69906V18.7726C19.2 20.0686 18.1255 21.1191 16.8 21.1191H7.20005C5.87456 21.1191 4.80005 20.0686 4.80005 18.7726V4.69324ZM7.20005 11.7329C7.20005 11.0849 7.73731 10.5596 8.40005 10.5596H15.6C16.2628 10.5596 16.8 11.0849 16.8 11.7329C16.8 12.3809 16.2628 12.9062 15.6 12.9062H8.40005C7.73731 12.9062 7.20005 12.3809 7.20005 11.7329ZM8.40005 15.2528C7.73731 15.2528 7.20005 15.778 7.20005 16.426C7.20005 17.074 7.73731 17.5993 8.40005 17.5993H15.6C16.2628 17.5993 16.8 17.074 16.8 16.426C16.8 15.778 16.2628 15.2528 15.6 15.2528H8.40005Z"
      fill={color}
    />
  </svg>
);
